/* eslint-disable max-lines */
import { type TranslationDataObj } from './type';

export const data: TranslationDataObj = {
  'app.products.index': {
    title: {
      en: 'Products',
      fr: 'Produits',
    },
    description: {
      en: 'Create products one by one or in bulk, and build templates to structure their pages.',
      fr: 'Créez des produits un par un ou en masse, et construisez des modèles pour structurer leurs pages.',
    },
    newProduct: {
      en: 'New product',
      fr: 'Nouveau produit',
    },
    modalTitle: {
      en: 'New product',
      fr: 'Nouveau produit',
    },
    addSingleProduct: {
      en: 'Add a single product',
      fr: 'Ajouter un produit',
    },
    importInBulk: {
      en: 'Add products in Bulk',
      fr: 'Ajouter en groupe',
    },
    importInBulkDescription: {
      en: 'Import multiple products',
      fr: 'Importer plusieurs produits',
    },
    bulkTitle: {
      en: 'Add products in Bulk',
      fr: 'Ajouter des produits en masse',
    },
    uploadAndPreview: {
      en: 'Upload and preview',
      fr: 'Télécharger et prévisualiser',
    },
    errorCreatingProduct: {
      en: 'Error creating product, try again later',
      fr: 'Erreur lors de la création du produit, réessayer plus tard',
    },
    products: {
      en: 'Products',
      fr: 'Produits',
    },
    allProducts: {
      en: 'All products',
      fr: 'Tous les produits',
    },
    bulkImport: {
      en: 'Bulk imported',
      fr: 'Import de groupes',
    },
    manuallyAdded: {
      en: 'Manually added',
      fr: 'Ajouté manuellement',
    },
    template: {
      en: 'Template',
      fr: 'Template',
    },
    searchPlaceholder: {
      en: 'Search products',
      fr: 'Rechercher des produits',
    },
    comingSoon: {
      en: 'Coming Soon',
      fr: 'Bientôt disponible',
    },
    errorCreatingBulkGroup: {
      en: 'Error importing your file, try again later',
      fr: "Erreur lors de l'importation de votre fichier, réessayer plus tard",
    },
  },
  'app.products.upsell': {
    requestDemo: {
      en: 'Request a demo',
      fr: 'Demander une démo',
    },
    title: {
      en: 'Generate on-brand <br> <span class="text-gradient-accent font-display-2">product pages at scale</span>',
      fr: 'Générer des pages <br> produit<span class="text-gradient-accent font-display-2"> à grande échelle</span>',
    },
    description1: {
      en: '<span class="text-branding-accent-800 font-body-2-sb">Create hundreds of product pages in minutes</span> with fast, bulk generation.',
      fr: '<span class="text-branding-accent-800 font-body-2-sb">Créez des centaines de pages produit en quelques minutes</span> avec la création de contenu alimentée par l’IA.',
    },
    description2: {
      en: '<span class="text-branding-accent-800 font-body-2-sb">Update existing pages automatically</span> following your site’s template and SEO structure.',
      fr: '<span class="text-branding-accent-800 font-body-2-sb">Mettez à jour les pages existantes automatiquement</span> en suivant la structure de votre site et le modèle SEO.',
    },
    description3: {
      en: '<span class="text-branding-accent-800 font-body-2-sb">Stay perfectly on-brand</span>, as Blym reproduces your unique tone of voice and way of addressing your customers.',
      fr: '<span class="text-branding-accent-800 font-body-2-sb">Restez parfaitement sur-mesure</span>, car Blym reproduit votre ton unique et votre façon de parler à vos clients.',
    },
  },
  'app.products.single-product-form': {
    title: {
      en: 'New product',
      fr: 'Nouveau produit',
    },
    productTitle: {
      en: 'Product title',
      fr: 'Titre du produit',
    },
    productTitlePlaceholder: {
      en: 'Type your product’s name here...',
      fr: 'Entrez le nom de votre produit ici...',
    },
    productKeyword: {
      en: 'SEO keyword or query',
      fr: 'Mot-clé SEO ou requête',
    },
    productKeywordPlaceholder: {
      en: 'Enter the keyword you want to rank on Google',
      fr: 'Entrez le mot-clé que vous souhaitez classer sur Google',
    },
  },
  'app.products.bulk-method-form': {
    bulkTitle: {
      en: 'Bulk name',
      fr: 'Nom en lot',
    },
    importProductCsv: {
      en: 'Import Product CSV',
      fr: 'Importer CSV de produits',
    },
    bulkTitlePlaceholder: {
      en: 'Type your product’s group name here...',
      fr: 'Entrez le nom du groupe de produits ici...',
    },
    dropFileHereToUpload: {
      en: 'Select or drop a CSV file to import',
      fr: 'Sélectionnez ou déposez un fichier CSV pour importer',
    },
    dropFileDescription: {
      en: 'Files must be less then {{size}}MB',
      fr: 'Les fichiers doivent être inférieurs à {{size}}MB',
    },
    productTemplatePlaceholder: {
      en: 'Select a template',
      fr: 'Sélectionnez un modèle',
    },
    productTemplate: {
      en: 'Product template',
      fr: 'Modèle de produit',
    },
    titleTooltipTheme: {
      en: 'Select a product template',
      fr: 'Sélectionnez un modèle de produit',
    },
    descTemplateTooltip: {
      en: 'Each template defines how your content is structured and displayed, including sections like title, description, images, and more.',
      fr: 'Chaque modèle définit la structure et l’affichage de votre contenu, y compris les sections comme le titre, la description, les images, etc.',
    },
    errorCreatingBulkGroup: {
      en: 'Error creating bulk group, try again later',
      fr: 'Erreur lors de la création du groupe en lot, réessayer plus tard',
    },
    errorCsvMissingHeaders: {
      en: 'CSV file is missing required headers. Please check your file format.',
      fr: 'Le fichier CSV ne contient pas les en-têtes requis. Veuillez vérifier le format de votre fichier.',
    },
    errorCsvInvalidFormat: {
      en: 'Invalid CSV file format. Please ensure your file is properly formatted.',
      fr: 'Format de fichier CSV invalide. Assurez-vous que votre fichier est correctement formaté.',
    },
    errorFileTooLarge: {
      en: 'File size exceeds the maximum limit. Please upload a smaller file.',
      fr: 'La taille du fichier dépasse la limite maximale. Veuillez télécharger un fichier plus petit.',
    },
    errorCsvNoDataRows: {
      en: 'CSV file contains no data rows. Please check your file format.',
      fr: 'Le fichier CSV ne contient pas de données. Veuillez vérifier le format de votre fichier.',
    },
    errorInvalidFileType: {
      en: 'Invalid file type. Only CSV files are accepted.',
      fr: 'Type de fichier invalide. Seuls les fichiers CSV sont acceptés.',
    },
  },
  'app.products.single-product-listing': {
    product: {
      en: 'Product',
      fr: 'Produit',
    },
    productCategory: {
      en: 'Product type',
      fr: 'Catégorie',
    },
    brand: {
      en: 'Brand',
      fr: 'Marque',
    },
    status: {
      en: 'Status',
      fr: 'Statut',
    },
    lastUpdated: {
      en: 'Last updated',
      fr: 'Dernière maj.',
    },
    emptyProductTitle: {
      en: 'Start generating content for your product',
      fr: 'Commencez à générer du contenu pour votre produit',
    },
    emptyProductDescription: {
      en: 'Get started by adding your first product',
      fr: 'Commencez par ajouter votre premier produit',
    },
    emptyProductButton: {
      en: 'New product',
      fr: 'Nouveau produit',
    },
    retryGeneration: {
      en: 'Retry generation',
      fr: 'Réessayer la génération',
    },
    read: {
      en: 'Read',
      fr: 'Lire',
    },
    unread: {
      en: 'Unread',
      fr: 'Non lu',
    },
    toReview: {
      en: 'To review',
      fr: 'À revoir',
    },
    approved: {
      en: 'Approved',
      fr: 'Approuvé',
    },
    lastUpdatedBy: {
      en: 'Last updated by {{author}}',
      fr: 'Mise à jour par {{author}}',
    },
    generatingContent: {
      en: 'Generating content',
      fr: 'Génération',
    },
    generationError: {
      en: 'Generation error',
      fr: 'Erreur de génération',
    },
    changeStatus: {
      en: 'Change status',
      fr: 'Changer le statut',
    },
    deleteContent: {
      en: 'Delete content',
      fr: 'Supprimer le contenu',
    },
    deleteContentDescription: {
      en: 'Are you sure you want to delete your products?',
      fr: 'Êtes-vous sûr de vouloir supprimer ces produits ?',
    },
  },
  'app.products.template-listing': {
    emptyTemplateTitle: {
      en: 'Create your product template',
      fr: 'Créez votre modèle de produit',
    },
    emptyTemplateDescription: {
      en: 'Set up the structure of your product page',
      fr: 'Configurez la structure de votre page produit',
    },
    emptyTemplateButton: {
      en: 'Create new template',
      fr: 'Créer un nouveau modèle',
    },
  },
  'app.product.$id': {
    reviewEditProduct: {
      en: 'Review & edit product',
      fr: 'Réviser et modifier le produit',
    },
    generatedContent: {
      en: 'Generated content',
      fr: 'Contenu généré',
    },
  },
  'app.funnel.product.$id._layout-funnel.product-info': {
    title: {
      en: 'Product information',
      fr: 'Informations du produit',
    },
    brandName: {
      en: 'Brand ',
      fr: 'Marque',
    },
    uniqueID: {
      en: 'Unique identifier ',
      fr: 'ID unique',
    },
    productType: {
      en: 'Product type',
      fr: 'Type de produit',
    },
    productTypePlaceholder: {
      en: 'Categorize your product',
      fr: 'Catégoriser votre produit',
    },
    aiGuidances: {
      en: 'AI guidance',
      fr: 'Guidance AI',
    },
    aiGuidancesDesc: {
      en: 'The more context you provide, the better the AI can generate high-quality, relevant, and unique content',
      fr: 'Plus de contexte vous fournissez, meilleur l’IA peut générer du contenu de haute qualité, pertinent et unique',
    },
    productImages: {
      en: 'Product images',
      fr: 'Images du produit',
    },
    productExtraDocuments: {
      en: 'Product extra documents',
      fr: 'Documents supplémentaires du produit',
    },
    additionalInformation: {
      en: 'Additional information',
      fr: 'Informations supplémentaires',
    },
    additionalInformationPlaceholder: {
      en: 'Provide key guidelines that the AI should follow.',
      fr: 'Fournir des directives clés que l’IA doit suivre.',
    },
    extraContentOption: {
      en: 'Extra content option',
      fr: 'Option contenu supplémentaire',
    },
    useInstructionsOnly: {
      en: 'Generate content using my input only',
      fr: 'Générer du contenu en utilisant uniquement mes instructions',
    },
  },
  'app.funnel.product.$id._layout-funnel.bulk-import': {
    title: {
      en: 'Import preview',
      fr: "Prévisualisation de l'importation",
    },
    description: {
      en: 'Import multiple products',
      fr: 'Importer plusieurs produits',
    },
    generateCount: {
      en: 'You will generate {{count}} products content.',
      fr: 'Vous allez générer du contenu pour {{count}} produits.',
    },
    reviewData: {
      en: "Review the data and values you are about to import. Here's some examples:",
      fr: "Examinez les données et les valeurs que vous êtes sur le point d'importer. Voici quelques exemples :",
    },
    descriptionLabel: {
      en: 'Description',
      fr: 'Description',
    },
    brandLabel: {
      en: 'Brand',
      fr: 'Marque',
    },
    import: {
      en: 'Import',
      fr: 'Import',
    },
    templates: {
      en: 'Templates',
      fr: 'Modèles',
    },
    generating: {
      en: 'Generating',
      fr: 'Génération',
    },
    productInformation: {
      en: 'Product information',
      fr: 'Informations du produit',
    },
  },
  'app.funnel.product.$id._layout-funnel.index': {
    title: {
      en: 'Pick a template to define your product page structure',
      fr: 'Choisissez un modèle pour définir la structure de votre page produit',
    },
    subTitle: {
      en: 'Blym will generate all the fields from the template automatically. <0>Learn more</0>',
      fr: 'Blym générera automatiquement tous les champs du modèle. <0>En savoir plus</0>',
    },
    createNewTemplate: {
      en: 'Create a new template',
      fr: 'Créer un nouveau modèle',
    },
    generateContent: {
      en: 'Generate content',
      fr: 'Générer du contenu',
    },
  },
  'app.product-template.new': {
    newTemplate: {
      en: 'New Template',
      fr: 'Nouveau modèle',
    },
    saveTemplate: {
      en: 'Save template',
      fr: 'Enregistrer le modèle',
    },
  },
  'app.product-template.edit': {
    warningModalTitle: {
      en: 'This template is used by one or more product pages.',
      fr: 'Ce modèle est utilisé par une ou plusieurs pages produit.',
    },
    warningModalDescription: {
      en: 'Changes will apply to all of them.',
      fr: 'Les modifications seront appliquées à toutes les pages.',
    },
    editTemplate: {
      en: 'Edit template',
      fr: 'Modifier le modèle',
    },
  },
  'app.funnel.product.$id.-components.template-cards': {
    fields: {
      en: '{{count}} fields',
      fr: '{{count}} champs',
    },
    templateDuplicated: {
      en: 'Template duplicated',
      fr: 'Modèle dupliqué',
    },
  },
  'app.funnel.product.$id.-components.product-template-editor': {
    title: {
      en: 'Create a new template',
      fr: 'Créer un nouveau modèle',
    },
    subTitle: {
      en: 'Define key fields for your CMS or product pages with clear, specific guidance. The more context you provide, the better the AI can generate high-quality, relevant, and unique content.',
      fr: `Définissez les champs clés de votre CMS ou pages produits avec des instructions claires et spécifiques. Plus vous fournissez de contexte, mieux l'IA peut générer du contenu de qualité, pertinent et unique.`,
    },
    generalPageInformation: {
      en: 'General page information',
      fr: 'Informations générales de la page',
    },
    templateNameLabel: {
      en: 'Template name',
      fr: 'Nom du modèle',
    },
    templateNamePlaceholder: {
      en: 'Name your page structure...',
      fr: 'Nommez votre structure de page...',
    },
    templateAdditionalInformationLabel: {
      en: 'Additional information (optional)',
      fr: 'Informations supplémentaires (optionnel)',
    },
    templateAdditionalInformationPlaceholder: {
      en: 'Add guidelines for content generation (e.g., "Focus on texture and scent for beauty products", "Emphasize fit and fabric feel for fashion items")',
      fr: `Ajoutez des directives pour la génération de contenu (ex. : "Concentrez-vous sur la texture et le parfum pour les produits de beauté", "Mettez l'accent sur la coupe et le toucher du tissu pour les articles de mode")`,
    },
    pageSections: {
      en: 'Page sections',
      fr: 'Sections de la page',
    },
    addNewField: {
      en: 'Add new field',
      fr: 'Ajouter un nouveau champ',
    },
    sectionTitle: {
      en: 'Section title',
      fr: 'Titre de la section',
    },
    sectionTitlePlaceholder: {
      en: 'Name your section...',
      fr: 'Nommez votre section...',
    },
    sectionDescription: {
      en: 'Description',
      fr: 'Description',
    },
    sectionDescriptionPlaceholder: {
      en: 'Add instructions...',
      fr: 'Ajoutez des instructions...',
    },
    allowHeadingsStructure: {
      en: 'Allow headings structure',
      fr: 'Autoriser la structure de titres',
    },
    allowListsStructure: {
      en: 'Allow lists structure',
      fr: 'Autoriser la structure de listes',
    },
    contentStructureOptions: {
      en: 'Content structure options',
      fr: 'Options de structure du contenu',
    },
    examples: {
      en: 'Examples (optional)',
      fr: 'Exemples (optionnel)',
    },
    examplesPlaceholder: {
      en: 'Paste examples to help AI understand the expected format and style for this field...',
      fr: `Collez des exemples pour aider l'IA à comprendre le format et le style attendus pour ce champ...`,
    },
    unableToCreateNewTemplate: {
      en: 'Unable to create new template',
      fr: 'Impossible de créer un nouveau modèle',
    },
    maxNumberOfWords: {
      en: 'Max number of words',
      fr: 'Nombre maximum de mots',
    },
    maxNumberOfWordsPlaceholder: {
      en: 'Max number of words for this section',
      fr: 'Nombre maximum de mots pour cette section',
    },
  },
  'app.funnel.product.$id.-components.template-preview': {
    instructions: {
      en: 'Instructions',
      fr: 'Instructions',
    },
    templatePreview: {
      en: 'Template preview',
      fr: 'Aperçu du modèle',
    },
    templatePreviewDescription: {
      en: 'This is a preview of template: {{template}}',
      fr: 'Ceci est un aperçu du modèle : {{template}}',
    },
    // eslint-disable-next-line camelcase
    field_one: {
      en: '{{count}} field',
      fr: '{{count}} champ',
    },
    // eslint-disable-next-line camelcase
    field_other: {
      en: '{{count}} fields',
      fr: '{{count}} champs',
    },
  },
  'app.funnel.product.$id.-components.confirm-template-deletion': {
    confirmation: {
      en: 'Are you sure you want to delete this template?',
      fr: 'Êtes-vous sûr de vouloir supprimer ce modèle ?',
    },
    dialogDescription: {
      en: 'Please confirm if you want to delete this template',
      fr: 'Veuillez confirmer si vous souhaitez supprimer ce modèle',
    },
  },
  'app.products.bulk-card': {
    viewProducts: {
      en: 'View products',
      fr: 'Voir',
    },
    resume: {
      en: 'Resume',
      fr: 'Reprendre',
    },
    export: {
      en: 'Export',
      fr: 'Exporter',
    },
    delete: {
      en: 'Delete',
      fr: 'Supprimer',
    },
    continueEditing: {
      en: 'Continue editing',
      fr: 'Continuer la modification',
    },
    products: {
      en: '{{count}} products',
      fr: '{{count}} produits',
    },
  },
  'app.products.bulk-import': {
    backToBulkImportList: {
      en: 'Back to Bulk imported list',
      fr: 'Retour à la liste des importations en masse',
    },
    products: {
      en: 'Products',
      fr: 'Produits',
    },
  },
  'app.products.bulk-delete-modal': {
    deleteBulk: {
      en: 'Delete ‘{{title}}’?',
      fr: 'Supprimer ‘{{title}}’ ?',
    },
    deleteBulkDescription: {
      en: 'This bulk import has {{count}} products. What would you like to do?',
      fr: 'Ce groupe d’importation en masse contient {{count}} produits. Que souhaitez-vous faire ?',
    },
    deleteAllProducts: {
      en: 'Delete bulk import and products',
      fr: 'Supprimer le groupe et les produits',
    },
    deleteSelectedProducts: {
      en: 'Delete bulk import only',
      fr: 'Supprimer le groupe uniquement',
    },
  },
  'app.funnel.bulk-import.$id.index': {
    titlePage: {
      en: 'Confirm Import',
      fr: "Confirmer l'importation",
    },
    detectedProducts: {
      en: 'We’ve detected <strong>{{count}} products</strong> in your file. Here’s a preview of what you uploaded:',
      fr: 'Nous avons détecté <strong>{{count}} produits</strong> dans votre fichier. Voici un aperçu de ce que vous avez téléchargé :',
    },
    import: {
      en: 'Import',
      fr: 'Importer',
    },
    title: {
      en: 'Title',
      fr: 'Titre',
    },
    uniqueIdentifier: {
      en: 'Unique identifier',
      fr: 'ID unique',
    },
    primaryKeyword: {
      en: 'Primary keyword',
      fr: 'Mot-clé principal',
    },
    brandName: {
      en: 'Brand name',
      fr: 'Nom de la marque',
    },
    price: {
      en: 'Price',
      fr: 'Prix',
    },
    productType: {
      en: 'Product type',
      fr: 'Type de produit',
    },
    extraInformation: {
      en: 'Extra information',
      fr: 'Informations supplémentaires',
    },
    filesUrls: {
      en: 'Files sources',
      fr: 'Fichiers sources',
    },
    allowedToScrapeSupplier: {
      en: 'Allowed to scrape supplier',
      fr: 'Autoriser le scraping du fournisseur',
    },
    websiteUrl: {
      en: 'Website URL',
      fr: 'URL du site web',
    },
    numberOfWords: {
      en: 'Number of words',
      fr: 'Nombre de mots',
    },
    requireImages: {
      en: 'Require Images',
      fr: 'Images obligatoires',
    },
    requireImagesDescription: {
      en: 'Prevent generation when no image is available',
      fr: 'Empêcher la génération lorsqu’aucune image n’est disponible',
    },
    saveAsDraft: {
      en: 'Save as draft',
      fr: 'Enregistrer le brouillon',
    },
    confirmAndGenerateProducts: {
      en: 'Confirm and generate ',
      fr: 'Confirmer et générer',
    },
    savedAsDraft: {
      en: 'Draft saved',
      fr: 'Brouillon enregistré',
    },
    errorGeneratingProducts: {
      en: 'Error generating products, try again later',
      fr: 'Erreur lors de la génération des produits, réessayer plus tard',
    },
    notEnoughCredits: {
      en: 'Not enough credits to generate',
      fr: 'Pas assez de crédits pour générer',
    },
    notEnoughCreditsDescription: {
      en: 'You have <b>{{credits}} credits left</b> but needed {{neededCredits}} to generate content for all products in this CSV. To increase your limit, reach out to your organization owner.',
      fr: 'Vous avez {{credits}} crédits restants mais vous en avez besoin de {{neededCredits}} pour générer du contenu pour tous les produits dans ce CSV. Pour augmenter votre limite, contactez le propriétaire de votre organisation.',
    },
    upgradePlan: {
      en: 'Upgrade plan',
      fr: 'Mettez à niveau votre plan',
    },
  },
  'app.funnel.bulk-import.$id.loading': {
    title: {
      en: 'Generating products',
      fr: 'Génération des produits',
    },
  },
};
